import api from './api';
class DataService {
  getPublicContent() {
    return api.get('inasistencia/index');
  }

  getInasistencia(institucion = null) {
    if (institucion) {
      return api.get('inasistencia/index/' + institucion);
    } else {
      return api.get('inasistencia/index');
    }
  }

  getMisInasistencia() {
      return api.get('mi-inasistencia');
  }
  
  getMotivos() {
      return api.get('motivos/get');
  }

  getEstados() {
      return api.get('estados/get');
  }

  getUserAccess(institutionId) {
    return api.get(`usuario/index`, {
      params: { institucion_id: institutionId }
    });
  }

  getUserAccessForId(userId) {
    return api.get(`usuario/index`, {
      params: { user_id: userId }
    });
  }

  getInstitution() {
    return api.get(`usuario/institucion/list`);
  }

  getRoles() {
    return api.get(`usuario/rol/list`);
  }

  getInasistenciaInstitucion(institucion) {
    return api.get('inasistencia/index/'+institucion);
  }

  /**
   * Solicitudes con paginación y búsqueda en servidor (endpoint dedicado).
   * Params: length, start, draw, search (objeto con .value), fecha_inicio, fecha_fin.
   */
  getInasistenciaPaginated(params, institucionId = null) {
    const path = institucionId
      ? `inasistencia/paginated/${institucionId}`
      : 'inasistencia/paginated';
    return api.get(path, { params });
  }

  getCieCode(code) {
    return api.post('cie10/get',{
      descripcion: code
    });
  }

  getDocument(licenciaId) {
    return api.get(`inasistencia/download/${licenciaId}`,{
      responseType: "blob",
    });
  }

  getHistorialLicencias(userId, institucionId = null) {
    const path = institucionId
      ? `inasistencia/historial-licencias/${userId}/${institucionId}`
      : `inasistencia/historial-licencias/${userId}`;
    return api.get(path);
  }

  postRequestCreate(solicitud) {
    return api.post('inasistencia/store',
      solicitud
    );
  }

  /** Bloquear solicitud para edición (al abrir modal). */
  lockInasistencia(id, institucionId) {
    return api.post('inasistencia/lock', { id, institucion_id: institucionId });
  }

  /** Liberar bloqueo al cerrar el modal. */
  unlockInasistencia(id) {
    return api.post('inasistencia/unlock', { id });
  }

  /** Estadísticas y reportes (solo PERSONAL/PROFESIONAL) */
  getEstadisticasPorInstitucionMes(params) {
    return api.get('inasistencia/estadisticas/por-institucion-mes', { params });
  }
  getEstadisticasPorEstado(params) {
    return api.get('inasistencia/estadisticas/por-estado', { params });
  }
  getEstadisticasPorMotivo(params) {
    return api.get('inasistencia/estadisticas/por-motivo', { params });
  }
  getEstadisticasPorTipoLicencia(params) {
    return api.get('inasistencia/estadisticas/por-tipo-licencia', { params });
  }
  getEstadisticasDiasPorMes(params) {
    return api.get('inasistencia/estadisticas/dias-por-mes', { params });
  }
  getEstadisticasTendenciaMensual(params) {
    return api.get('inasistencia/estadisticas/tendencia-mensual', { params });
  }
  getEstadisticasTopInstituciones(params) {
    return api.get('inasistencia/estadisticas/top-instituciones', { params });
  }
  getEstadisticasPorCie10(params) {
    return api.get('inasistencia/estadisticas/por-cie10', { params });
  }

  /** Lista de instituciones permitidas para estadísticas (mismo permiso LICENCIA_VIEW, sin USUARIO_*). */
  getEstadisticasInstituciones() {
    return api.get('inasistencia/estadisticas/instituciones');
  }

  /** Comparativa por años: instituciones, cantidades, aprobadas/rechazadas. Params: anos (opcional, ej. "2022,2023,2024"). */
  getEstadisticasComparativaAnos(params = {}) {
    return api.get('inasistencia/estadisticas/comparativa-anos', { params });
  }

  /** Porcentaje de personal ausentado (con al menos una licencia aprobada en el período) por institución. */
  getEstadisticasPorcentajePersonalAusentadoInstitucion(params) {
    return api.get('inasistencia/estadisticas/porcentaje-personal-ausentado-institucion', { params });
  }

  /** Estadísticas para Personal: solo instituciones que gestiona el usuario. */
  getEstadisticasPersonalInstituciones() {
    return api.get('inasistencia/estadisticas-personal/instituciones');
  }
  getEstadisticasPersonalPorInstitucionMes(params) {
    return api.get('inasistencia/estadisticas-personal/por-institucion-mes', { params });
  }
  getEstadisticasPersonalPorEstado(params) {
    return api.get('inasistencia/estadisticas-personal/por-estado', { params });
  }
  getEstadisticasPersonalPorMotivo(params) {
    return api.get('inasistencia/estadisticas-personal/por-motivo', { params });
  }
  getEstadisticasPersonalPorTipoLicencia(params) {
    return api.get('inasistencia/estadisticas-personal/por-tipo-licencia', { params });
  }
  getEstadisticasPersonalDiasPorMes(params) {
    return api.get('inasistencia/estadisticas-personal/dias-por-mes', { params });
  }
  getEstadisticasPersonalTendenciaMensual(params) {
    return api.get('inasistencia/estadisticas-personal/tendencia-mensual', { params });
  }
  getEstadisticasPersonalTopInstituciones(params) {
    return api.get('inasistencia/estadisticas-personal/top-instituciones', { params });
  }
  getEstadisticasPersonalPorCie10(params) {
    return api.get('inasistencia/estadisticas-personal/por-cie10', { params });
  }
  getEstadisticasPersonalComparativaAnos(params = {}) {
    return api.get('inasistencia/estadisticas-personal/comparativa-anos', { params });
  }
  getEstadisticasPersonalPorcentajePersonalAusentadoInstitucion(params) {
    return api.get('inasistencia/estadisticas-personal/porcentaje-personal-ausentado-institucion', { params });
  }
}

export default new DataService();